import { FETCH_LOGIN, FAILED_LOGIN, RECEIVE_LOGIN, FETCH_LOGOUT, RECEIVE_LOGOUT, FETCH_CHECK_AUTH, RECEIVE_CHECK_AUTH, RECEIVE_ACCESS } from '../actions/auth.actions.js';


const defaultAuthState = {
    authData: [],
    inProgress: false,
    isAuthenticated: false,
    id_roles: 0,
    name: '',
    email: '',
    subs: {},  
    access: []
}
var newAuthState;

export function fetchAuth(state = defaultAuthState, action) {
    switch (action.type) {
        case RECEIVE_ACCESS:
            return {...state, access: [...action.payload]}
        case FETCH_LOGIN: 
            return ({
                authData: null,
                inProgress: true,
                isAuthenticated: false,
                id_roles: 0,
                name: '',
                email: '',
                subs: {}
            });
        case RECEIVE_LOGIN:
            newAuthState = action.payload;
            return Object.assign(
                {},
                state,
                newAuthState,
                {
                    authData: newAuthState,
                    subs: action.payload.result.subs,
                    id_roles: action.payload.result.id_roles,
                    name: action.payload.result.name,
                    email: action.payload.result.email,
                    inProgress: false,
                    isAuthenticated: true
                }
            );
        case FAILED_LOGIN: 
            return ({
                authData: null,
                inProgress: false,
                name: '',
                email: '',
                isAuthenticated: false,
                subs: {}
            });

        // case REHYDRATE:
        //     if(localStorage.getItem("TCNOPlt") === null || localStorage.getItem("TCNOPlt") === undefined) {
        //         return {}
        //     }

        case FETCH_LOGOUT: 
            return ({
                ...state,
                inProgress: true
            })
        case RECEIVE_LOGOUT:
            newAuthState = null
            return ({
                authData: null,
                inProgress: false,
                isAuthenticated: false
            })
        case FETCH_CHECK_AUTH:
            return ({
                ...state,
                inProgress: true,
                isAuthenticated: false
            })
        case RECEIVE_CHECK_AUTH:
            // console.log(newAuthState);
            if(newAuthState === '[]') {
                return ({
                    authData: null,
                    inProgress: false,
                    isAuthenticated: true
                })
            } else if(newAuthState == null) {
                return({
                    ...state,
                    inProgress: false,
                    isAuthenticated: false
                });
            } else if(newAuthState != null) {
                return({
                    ...state,
                    inProgress: false,
                    isAuthenticated: true
                });
            } else {
                return({
                    ...state,
                    inProgress: false,
                    isAuthenticated: true
                });
            }
        default:
            return state;
    }
}